import { localStore } from 'utils/storage'

const localeStorageKey = 'cf-studio-dark-mode'
const validStates = new Set(['dark', 'light'])

export function storePreference(state: 'dark' | 'light') {
  if (state === 'light') {
    localStore.setString(localeStorageKey, state)
    return
  }

  localStore.setString(localeStorageKey, state)
  return
}

export function applyPreference(state: 'dark' | 'light') {
  if (state === 'light') {
    document.documentElement.classList.remove('dark')
    return
  }

  document.documentElement.classList.add('dark')
  return
}

export function getStoredPreference() {
  const storageValue = localStore.getString(localeStorageKey)
  if (storageValue && validStates.has(storageValue)) {
    return storageValue as 'dark' | 'light'
  }
  return undefined
}
